/**
 * Il messaggio da mostrare quando qualcosa non è andato.
 *
 * Il backend prepara già la frase in italiano — «Il gestionale non ha
 * accettato la modifica», «Sotto il prezzo minimo» — e questa la tira fuori
 * dall'errore invece di sostituirla con un generico. Serve un posto solo,
 * perché prima ogni componente se lo scriveva da sé e in sette punti non se
 * lo scriveva affatto: la richiesta falliva e a schermo non compariva niente.
 */

import { ApiError } from "./api.ts";

export function messaggioDi(
  errore: unknown,
  fallback = "Non è andata: riprova.",
): string {
  if (errore instanceof ApiError) return errore.message;
  // Rete giù, server spento: `fetch` alza un TypeError senza niente di utile
  // dentro, e dirlo com'è aiuta più che ripetere "riprova".
  if (errore instanceof TypeError)
    return "Non riesco a raggiungere il server. È ancora avviato?";
  if (errore instanceof Error && errore.message) return errore.message;
  return fallback;
}
